
import { Button } from "@/components/ui/Button";
import { Input } from "@/components/ui/Input";
import { cn } from "@/lib/utils";
import { useCallback } from "react";

interface PromptInputProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  isLoading: boolean;
  compact?: boolean;
  onFocus?: () => void;
  onBlur?: () => void;
  disabled?: boolean;
}

export function PromptInput({
  value,
  onChange,
  onSubmit,
  isLoading,
  compact = false,
  onFocus,
  onBlur,
  disabled = false,
}: PromptInputProps) {
  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        onSubmit();
      }
    },
    [onSubmit],
  );

  return (
    <div
      className={cn(
        "flex gap-3 items-center w-full",
        compact ? "max-w-xl" : "max-w-2xl mx-auto",
      )}
    >
      <div className="flex-1 relative">
        <Input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={handleKeyDown}
          onFocus={onFocus}
          onBlur={onBlur}
          placeholder="Describe your inner world..."
          disabled={isLoading || disabled}
          accent="sand"
          inputSize={compact ? "sm" : "lg"}
          className={cn(!compact && "rounded-xl border")}
        />
      </div>
      <Button
        onClick={onSubmit}
        disabled={isLoading || disabled || !value.trim()}
        size={compact ? "sm" : "default"}
        className={cn(!compact && "rounded-xl")}
      >
        {isLoading ? "Creating..." : "Create"}
      </Button>
    </div>
  );
}
